export default __webpack_public_path__ + "static/media/about_banner_text.1de1a2cb.png";